import script from "./couponsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./couponsDetail.vue?vue&type=script&setup=true&lang=js"

import "./couponsDetail.vue?vue&type=style&index=0&id=33a42ea6&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a42ea6"]])

export default __exports__